import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { cauHinhLoaiDichVuApi } from "../../../api/dich-vu/cauHinhLoaiDichVuApi";
import { loaiDichVuApi } from "../../../api/dich-vu/loaiDichVuApi";
import { IBaseResponeModel } from "../../../models/response/base-response";
import {
	eCauHinhLoaiDichVuActionTypeIds,
	ICauHinhLoaiDichVuDeleteStart,
	ICauHinhLoaiDichVuLoadDetailStart,
	ICauHinhLoaiDichVuLoadStart,
	ICauHinhLoaiDichVuSaveStart
} from "../../action-types/dich-vu/ICauHinhLoaiDichVuActionTypes";
import { cauHinhLoaiDichVuActions } from "../../actions/dich-vu/cauHinhLoaiDichVuActions";

export function* cauHinhLoaiDichVuSaga(): any {
	yield takeLatest(eCauHinhLoaiDichVuActionTypeIds.LOAD_START, loadCauHinhLoaiDichVuWorker)
	yield takeLatest(eCauHinhLoaiDichVuActionTypeIds.LOAD_LOAIDICHVU_START, loadLoaiDichVuWorker)
	yield takeLatest(eCauHinhLoaiDichVuActionTypeIds.LOAD_DETAIL_START, loadCauHinhLoaiDichVuDetailWorker)
	yield takeEvery(eCauHinhLoaiDichVuActionTypeIds.SAVE_START, saveCauHinhLoaiDichVuWorker)
	yield takeEvery(eCauHinhLoaiDichVuActionTypeIds.DELETE_START, deleteCauHinhLoaiDichVuWorker)
}

function* loadCauHinhLoaiDichVuWorker(action: ICauHinhLoaiDichVuLoadStart): any {
	const res: IBaseResponeModel = yield call([cauHinhLoaiDichVuApi, cauHinhLoaiDichVuApi.Select], action.payload)
	if (res.is_success) {
		yield put(cauHinhLoaiDichVuActions.loadCauHinhLoaiDichVuSuccess(res.data || []))
	} else {
		yield put(cauHinhLoaiDichVuActions.loadCauHinhLoaiDichVuError(res.message || "Không tải được danh sách cấu hình loại dịch vụ"))
	}
}

function* loadLoaiDichVuWorker(): any {
	const res: IBaseResponeModel = yield call([loaiDichVuApi, loaiDichVuApi.SelectAll])
	if (res.is_success) {
		yield put(cauHinhLoaiDichVuActions.loadLoaiDichVuSuccess(res.data || []))
	} else {
		yield put(cauHinhLoaiDichVuActions.loadLoaiDichVuError(res.message || "Không tải được danh sách loại dịch vụ"))
	}
}

function* loadCauHinhLoaiDichVuDetailWorker(action: ICauHinhLoaiDichVuLoadDetailStart): any {
	const res: IBaseResponeModel = yield call([cauHinhLoaiDichVuApi, cauHinhLoaiDichVuApi.SelectById], action.payload)
	if (res.is_success) {
		if (res.data) {
			yield put(cauHinhLoaiDichVuActions.loadCauHinhLoaiDichVuDetailSuccess(res.data))
		}
	} else {
		yield put(cauHinhLoaiDichVuActions.loadCauHinhLoaiDichVuDetailError(res.message || "Không tải được chi tiết cấu hình loại dịch vụ"))
	}
}

function* saveCauHinhLoaiDichVuWorker(action: ICauHinhLoaiDichVuSaveStart): any {
	let res: IBaseResponeModel;
	const is_update = action.payload.id > 0;
	if (is_update) {
		res = yield call([cauHinhLoaiDichVuApi, cauHinhLoaiDichVuApi.Update], action.payload);
	} else {
		res = yield call([cauHinhLoaiDichVuApi, cauHinhLoaiDichVuApi.Insert], action.payload);
	}
	if (res.is_success) {
		yield put(cauHinhLoaiDichVuActions.saveCauHinhLoaiDichVuSuccess(is_update))
	} else {
		yield put(cauHinhLoaiDichVuActions.saveCauHinhLoaiDichVuError(res.message || "Không lưu được cấu hình loại dịch vụ"))
	}
}

function* deleteCauHinhLoaiDichVuWorker(action: ICauHinhLoaiDichVuDeleteStart): any {
	const res: IBaseResponeModel = yield call([cauHinhLoaiDichVuApi, cauHinhLoaiDichVuApi.Delete], action.payload)
	if (res.is_success) {
		yield put(cauHinhLoaiDichVuActions.deleteCauHinhLoaiDichVuSuccess())
	} else {
		yield put(cauHinhLoaiDichVuActions.deleteCauHinhLoaiDichVuError(res.message || "Không xoá được cấu hình loại dịch vụ"))
	}
}
